module.exports = __webpack_public_path__ + "img/copy.957847cd.png";